// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Deux fleches vers les coins opposes : agrandir la fenetre du centre de communication (« Agrandir »).
 *
 * Fournie par le fondateur pendant les retouches du 06/10/2026,
 * exportee en traces Potrace : cadre `0 0 240 240`, traces en dixiemes et
 * retournes (`translate(0 240) scale(.1 -.1)`), recopies tels quels.
 */
export const IconWindowExpand = createCustomIcon(
  'IconWindowExpand',
  '0 0 240 240',
  <>
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M1200 2200 l0 -130 347 0 348 0 -343 -343 -342 -342 87 -88 88 -87 342 342 343 343 0 -348 0 -347 130 0 130 0 -2 563 -3 562 -562 3 -563 2 0 -130z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M72 638 l3 -563 563 -3 562 -2 0 130 0 130 -347 0 -348 0 343 343 342 342 -87 88 -88 87 -342 -342 -343 -343 0 348 0 347 -130 0 -130 0 2 -562z" />
  </>,
);
